import styled from 'styled-components'

export const InputWrapper = styled.div`
  position: relative;

  &&& {
    > .icon {
      position: absolute;
      right: 3px;
      top: 7px;
    }
  }
`

export const TumblerWrapper = styled.div<{ visible: boolean }>`
  position: absolute;
  left: 0;
  top: 40px;
  background: white;
  z-index: 100;
  border: 1px solid #e6e8eb;
  border-radius: 4px;
  padding: 4px;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`

export const Tumbler = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 125px;
  height: 100px;
  position: relative;
`

export const Window = styled.div<{ selectedIndex: number }>`
  overflow: hidden;
  height: 50%;
  width: 100%;
  position: absolute;

  > div {
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
    transition-duration: 0.2s;
    transform: ${props => `translateY(${props.selectedIndex * -50}px)`};
  }
`

export const Number = styled.div`
  display: flex;
  font-size: 24px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    border: 1px solid #e6e8eb;
  }
`

export const NumberPickerWrapper = styled.div`
  padding: 6px;
`

export const NumberRow = styled.div`
  display: flex;
  gap: 10px;

  span {
    padding: 4px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid white;
    white-space: nowrap;

    &:hover {
      border: 1px solid #e6e8eb;
    }
  }
`
